import { setDefaultStyle } from "apparatus/draw";
import { P, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
import { CommonCondenser, condenserCaseShape } from "../condensers";
export class AllihnCondenser2 {
    render(appearance) {
        const { ports, height } = appearance;
        const { group: casing, snap: snapping } = condenserCaseShape(height, 15, ports);
        const insideTube1 = new Path(Segments([[-7.5, 0]], [[-7.5, 10]], [[-5, 25]]));
        const repeats = Math.floor((height - 60) / 35);
        const offset = (height - repeats * 35) / 2 + 5;
        for (let i = 0; i < repeats; i++) {
            const y = 35 * i + offset;
            insideTube1.addSegments(Segments([[-5, y], , [-7, 4]], [[-5, y + 25], [-7, -4]]));
        }
        insideTube1.addSegments(Segments([[-5, height - 25]], [[-7.5, height - 10]], [[-7.5, height]]));
        const insideTube2 = insideTube1.clone();
        insideTube2.scale(-1.0, 1.0, P(0, 0));
        let graphic = new Group([casing, insideTube1, insideTube2]);
        setDefaultStyle(graphic);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            snapping,
            pivot: P(0, height / 2)
        };
    }
}
AllihnCondenser2.properties = {
    label: "Allihn Condenser",
    flippable: true,
    defaultAppearance: Object.assign({}, CommonCondenser.defaultAppearance),
    appearanceSpecs: [
        ...CommonCondenser.appearanceSpecs,
    ],
    isBoostRequired: a => CommonCondenser.isBoostRequired(a)
};
